import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitAddClientsForce = {
  clients: string[];
};

export const addClientsForce = async (data: SubmitAddClientsForce) => {
  const response = await axios.post<SubmitAddClientsForce>(
    `${rootUrl}/psychologist/add/force/clients`,
    {
      clients: data.clients,
      token: getCookies('auth'),
    }
  );

  return response.data;
};
